var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.906 3.594C9.22 3.594 7.844 2.5 5.75 2.5c-.781 0-1.469.156-2.125.406.063-.219.094-.406.094-.625v-.125C3.688 1.281 2.938.562 2.063.531 1.063.47.25 1.281.25 2.25c0 .625.281 1.125.75 1.438V15.75c0 .438.313.75.75.75h.5a.74.74 0 0 0 .75-.75v-2.938c.875-.374 1.969-.687 3.563-.687 1.687 0 3.062 1.094 5.156 1.094 1.5 0 2.719-.531 3.844-1.281.25-.188.437-.5.437-.813V3.5c0-.719-.781-1.188-1.438-.906-1.062.5-2.374 1-3.656 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ea1b906bdb5d3460ac84079241f7ecdb.svg";
export { ForwardRef as ReactComponent };